import {
  COMPARISON_OPERATORS,
  FILTER_TYPES,
} from '@witmetrics/utils/constants';
import { getEndOfDay, getStartOfDay } from '@witmetrics/utils/time';
import { API } from '@/api';

export const classes = {
  overlay: 'h-full w-[750px] max-w-[98vw]',
  wrapper: 'px-0 size-full flex flex-col flex-1',
  agenda: 'overflow-y-auto pl-2 pr-4',
};

export async function fetchProjectTasks(practiceId: number, date: string) {
  // TODO: Pagination -- just doing a large pageSize for now
  const { results } = await API.Practices.fetchPracticeUnisonProjectTasks(
    practiceId,
    {
      pagination: { page: 1, pageSize: 500 },
      filters: buildFilters(date),
    }
  );
  return results;
}

export async function fetchOrderTasks(labId: number, date: string) {
  // TODO: Pagination -- just doing a large pageSize for now
  const { results } = await API.Labs.fetchLabOrderTasks(labId, {
    pagination: { page: 1, pageSize: 500 },
    filters: buildFilters(date),
  });
  return results;
}

export function buildFilters(date: string) {
  return [
    {
      filterType: FILTER_TYPES.COLUMN_VALUE,
      comparisonOperator: COMPARISON_OPERATORS.GREATER_THAN_OR_EQUALS.value,
      value: getStartOfDay(date),
      column: 'dueAt',
    },
    {
      filterType: FILTER_TYPES.COLUMN_VALUE,
      comparisonOperator: COMPARISON_OPERATORS.LESS_THAN_OR_EQUALS.value,
      value: getEndOfDay(date),
      column: 'dueAt',
    },
  ];
}
